import { useMutation } from '@tanstack/react-query';
import { makeCRMApi } from '..';

export const useDeleteCrmActivity = () => {
  const crmApi = makeCRMApi();

  const deleteCrmActivityMutation = useMutation({
    mutationKey: ['crm-delete-activity'],
    mutationFn: (activityId: string) => crmApi.deleteActivity(activityId),
  });

  return deleteCrmActivityMutation;
};
